import React from 'react'

const Repeat = ({ color = 'currentColor' }: { color?: string }) => {
  return (
    <svg
      width='21'
      height='20'
      viewBox='0 0 21 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1.91675 10C1.91675 14.6 5.65008 18.3333 10.2501 18.3333'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeDasharray='3 3'
      />
      <path
        d='M6.19628 4.16665C6.8181 3.73547 7.5345 3.35228 8.37413 3.07786C12.1683 1.83778 16.2461 3.90663 17.4862 7.70079C18.7263 11.4949 16.6574 15.5728 12.8633 16.8129'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.27626 4.67786L6.70591 1.29991'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.27637 4.67798L8.58261 5.75408'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default Repeat
